import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from '../components/home/HeroSection';
import { ValuePillars } from '../components/home/ValuePillars';
import { ProgramsPreview } from '../components/home/ProgramsPreview';
import { MidPageCTA } from '../components/home/MidPageCTA';
import { WhyTrainHere } from '../components/home/WhyTrainHere';
import { LocationsPreview } from '../components/home/LocationsPreview';
import { CTASection } from '../components/home/CTASection';
export function HomePage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-891">
      <Header data-id="element-892" />

      <main data-id="element-893">
        <HeroSection data-id="element-894" />
        <ValuePillars data-id="element-895" />
        <ProgramsPreview data-id="element-896" />
        <MidPageCTA data-id="element-897" />
        <WhyTrainHere data-id="element-898" />
        <LocationsPreview data-id="element-899" />
        <CTASection data-id="element-900" />
      </main>

      <Footer data-id="element-901" />
    </div>;
}